<div class="la-detail-dialog" [class.la-detail-dialog--pending-import]="isPendingImportOverview">
    <div class="la-detail-dialog__header" mat-dialog-title>
        <div class="la-detail-dialog__title-row">
            <span class="la-detail-dialog__aktion">{{ getAktionLabel() }}</span>
            <span class="item-chip" [ngClass]="getStatusChipClass()">{{ getStatusLabel() }}</span>
            <span *ngIf="displayAktionId" class="la-detail-dialog__aktion-id">ID {{ displayAktionId }}</span>
        </div>
        <button
            mat-icon-button
            type="button"
            class="la-detail-dialog__close"
            aria-label="Schließen"
            (click)="onCloseDialog()"
            [disabled]="isSaving"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="la-detail-dialog__content">
        <div *ngIf="isLoading" class="la-detail-dialog__loading">
            <mat-spinner diameter="36"></mat-spinner>
            <span>Daten werden geladen…</span>
        </div>

        <div *ngIf="!isLoading && loadError" class="la-detail-dialog__error">{{ loadError }}</div>

        <ng-container *ngIf="!isLoading && !loadError">
            <section class="la-detail-dialog__section la-detail-dialog__overview">
                <h3 class="la-detail-dialog__section-title la-detail-dialog__section-title--with-icon">
                    <mat-icon aria-hidden="true">{{
                        isPendingImportOverview ? 'inventory_2' : 'description'
                    }}</mat-icon>
                    {{ isPendingImportOverview ? 'Import' : 'Übersicht' }}
                </h3>
                <p *ngIf="isPendingImportOverview" class="la-detail-dialog__import-lead">
                    Tiere befinden sich noch auf der Ausstallliste. Die Zielgruppe wählen Sie beim Import.
                </p>

                <div class="la-detail-dialog__overview-grid">
                    <div class="la-detail-dialog__card la-detail-dialog__card--full">
                        <div class="la-detail-dialog__card-head">
                            <span class="la-detail-dialog__card-label">
                                <mat-icon aria-hidden="true">business</mat-icon>
                                Betrieb
                            </span>
                        </div>
                        <p class="la-detail-dialog__card-value">{{ overviewBetriebLabel }}</p>
                    </div>

                    <ng-container *ngIf="isPendingImportOverview; else standardOverviewMeta">
                        <div class="la-detail-dialog__overview-row la-detail-dialog__overview-row--import-ready">
                            <div class="la-detail-dialog__card">
                                <div class="la-detail-dialog__card-head">
                                    <span class="la-detail-dialog__card-label">
                                        <mat-icon aria-hidden="true">event</mat-icon>
                                        Datum
                                    </span>
                                </div>
                                <p class="la-detail-dialog__card-value">{{ row.datum | date: 'dd.MM.yyyy' }}</p>
                            </div>
                            <div class="la-detail-dialog__card">
                                <div class="la-detail-dialog__card-head">
                                    <span class="la-detail-dialog__card-label">
                                        <mat-icon aria-hidden="true">pets</mat-icon>
                                        Anzahl Tiere
                                    </span>
                                </div>
                                <ng-container *ngIf="canShowTiereSection; else anzahlPlainImport">
                                    <button
                                        type="button"
                                        class="la-detail-dialog__tiere-link"
                                        aria-label="Tiere in Tierliste anzeigen"
                                        [disabled]="tiereLoading"
                                        (click)="onOpenTiereModalActivate($event)"
                                    >
                                        <span class="la-detail-dialog__tiere-link-badge">{{
                                            displayAnzahlTiere
                                        }}</span>
                                        <span class="la-detail-dialog__tiere-link-text">Tiere anzeigen</span>
                                        <mat-spinner *ngIf="tiereLoading" diameter="18"></mat-spinner>
                                        <mat-icon *ngIf="!tiereLoading" aria-hidden="true">chevron_right</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-template #anzahlPlainImport>
                                    <p class="la-detail-dialog__card-value">{{ displayAnzahlTiere }}</p>
                                </ng-template>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #standardOverviewMeta>
                        <div class="la-detail-dialog__overview-row">
                            <div
                                class="la-detail-dialog__card la-detail-dialog__card--datum"
                                [class.la-detail-dialog__card--datum-editing]="isDatumEditing"
                            >
                                <div class="la-detail-dialog__card-head">
                                    <span class="la-detail-dialog__card-label">
                                        <mat-icon aria-hidden="true">event</mat-icon>
                                        Datum
                                    </span>
                                    <button
                                        *ngIf="canEditTierlisteMeta && !isDatumEditing"
                                        type="button"
                                        class="la-detail-dialog__card-edit"
                                        aria-label="Ausstalldatum bearbeiten"
                                        (click)="startDatumEdit($event)"
                                    >
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <div *ngIf="canEditTierlisteMeta && isDatumEditing" class="la-detail-dialog__card-actions">
                                        <button
                                            type="button"
                                            class="la-detail-dialog__card-icon-btn"
                                            aria-label="Ausstalldatum wählen"
                                            (click)="tierlisteDatumPicker.open()"
                                        >
                                            <mat-icon>calendar_today</mat-icon>
                                        </button>
                                        <button
                                            type="button"
                                            class="la-detail-dialog__card-icon-btn"
                                            aria-label="Ausstalldatum löschen"
                                            (click)="clearAusstalldatum()"
                                        >
                                            <mat-icon>clear</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <p
                                    class="la-detail-dialog__card-value"
                                    [class.la-detail-dialog__card-value--muted]="displayTierlisteDatumLabel === '—'"
                                >
                                    {{ displayTierlisteDatumLabel }}
                                </p>
                                <input
                                    *ngIf="canEditTierlisteMeta"
                                    #tierlisteDatumInput
                                    class="la-detail-dialog__hidden-date-input"
                                    [matDatepicker]="tierlisteDatumPicker"
                                    [formControl]="datumCtrl"
                                    tabindex="-1"
                                    aria-hidden="true"
                                />
                                <mat-datepicker #tierlisteDatumPicker (closed)="finishDatumEdit()"></mat-datepicker>
                            </div>
                            <div *ngIf="showGruppeOverview" class="la-detail-dialog__card">
                                <div class="la-detail-dialog__card-head">
                                    <span class="la-detail-dialog__card-label">
                                        <mat-icon aria-hidden="true">groups</mat-icon>
                                        Gruppe
                                    </span>
                                    <button
                                        *ngIf="canEditGruppe"
                                        type="button"
                                        class="la-detail-dialog__card-edit"
                                        aria-label="Gruppe für Tiere in der Liste ändern"
                                        [disabled]="tiereLoading"
                                        (click)="openGruppeAendern($event)"
                                    >
                                        <mat-spinner *ngIf="tiereLoading" diameter="16"></mat-spinner>
                                        <mat-icon *ngIf="!tiereLoading">edit</mat-icon>
                                    </button>
                                </div>
                                <p class="la-detail-dialog__card-value la-detail-dialog__card-value--link">
                                    <ng-container *ngIf="gruppeLinks.length; else gruppePlain">
                                        <ng-container *ngFor="let g of gruppeLinks; let last = last">
                                            <a
                                                [routerLink]="getGruppeDetailLink(g.gruppe_id)"
                                                class="la-detail-dialog__overview-link"
                                                (click)="onGruppeLinkClick($event, g.gruppe_id)"
                                                >{{ g.bezeichnung }}</a
                                            >
                                            <span *ngIf="!last">, </span>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #gruppePlain>{{ row.aktuelle_gruppe }}</ng-template>
                                </p>
                                <p *ngIf="gruppeLinks.length > 1" class="la-detail-dialog__card-note">
                                    Beim Speichern wird die erste Gruppe verwendet.
                                </p>
                            </div>
                        </div>

                        <div class="la-detail-dialog__overview-row">
                            <div class="la-detail-dialog__card">
                                <div class="la-detail-dialog__card-head">
                                    <span class="la-detail-dialog__card-label">
                                        <mat-icon aria-hidden="true">pets</mat-icon>
                                        Anzahl Tiere
                                    </span>
                                </div>
                                <ng-container *ngIf="canShowTiereSection; else anzahlPlain">
                                    <button
                                        type="button"
                                        class="la-detail-dialog__tiere-link"
                                        aria-label="Tiere in Tierliste anzeigen"
                                        [disabled]="tiereLoading"
                                        (click)="onOpenTiereModalActivate($event)"
                                    >
                                        <span class="la-detail-dialog__tiere-link-badge">{{
                                            displayAnzahlTiere
                                        }}</span>
                                        <span class="la-detail-dialog__tiere-link-text">Tiere anzeigen</span>
                                        <mat-spinner *ngIf="tiereLoading" diameter="18"></mat-spinner>
                                        <mat-icon *ngIf="!tiereLoading" aria-hidden="true">chevron_right</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-template #anzahlPlain>
                                    <p class="la-detail-dialog__card-value">{{ displayAnzahlTiere }}</p>
                                </ng-template>
                            </div>
                            <div *ngIf="showAbschnittOverview" class="la-detail-dialog__card">
                                <div class="la-detail-dialog__card-head">
                                    <span class="la-detail-dialog__card-label">
                                        <mat-icon aria-hidden="true">category</mat-icon>
                                        Abschnitt
                                    </span>
                                </div>
                                <p class="la-detail-dialog__card-value">{{ getAbschnittDisplay() }}</p>
                            </div>
                        </div>
                    </ng-template>

                    <div
                        *ngIf="isEinstallen"
                        class="la-detail-dialog__card la-detail-dialog__card--full"
                        [class.la-detail-dialog__card--herkunft-readonly]="isPendingImportOverview"
                    >
                        <div class="la-detail-dialog__card-head">
                            <span class="la-detail-dialog__card-label">
                                <mat-icon aria-hidden="true">place</mat-icon>
                                Herkunft
                            </span>
                            <button
                                *ngIf="canEditHerkunft"
                                type="button"
                                class="la-detail-dialog__card-edit"
                                aria-label="Herkunft bearbeiten"
                                [disabled]="tiereLoading"
                                (click)="openHerkunftSetzen($event)"
                            >
                                <mat-spinner *ngIf="tiereLoading" diameter="16"></mat-spinner>
                                <mat-icon *ngIf="!tiereLoading">edit</mat-icon>
                            </button>
                        </div>
                        <p
                            *ngIf="(row.herkunft || '').trim(); else herkunftEmpty"
                            class="la-detail-dialog__card-value"
                        >
                            {{ row.herkunft }}
                        </p>
                        <ng-template #herkunftEmpty>
                            <p class="la-detail-dialog__card-value la-detail-dialog__card-value--muted">
                                {{ canEditHerkunft ? 'Noch keine Herkunft gesetzt' : '—' }}
                            </p>
                        </ng-template>
                    </div>

                    <div
                        *ngIf="showTierlisteMetaFields"
                        class="la-detail-dialog__card la-detail-dialog__card--full la-detail-dialog__card--kommentar"
                        [class.la-detail-dialog__card--kommentar-editing]="isKommentarEditing"
                    >
                        <div class="la-detail-dialog__card-head">
                            <span class="la-detail-dialog__card-label">
                                <mat-icon aria-hidden="true">comment</mat-icon>
                                Kommentar
                            </span>
                            <button
                                *ngIf="canEditTierlisteMeta && !isKommentarEditing"
                                type="button"
                                class="la-detail-dialog__card-edit"
                                aria-label="Kommentar bearbeiten"
                                (click)="startKommentarEdit($event)"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                            <span *ngIf="canEditTierlisteMeta && isKommentarEditing" class="la-detail-dialog__kommentar-count">
                                {{ (kommentarCtrl.value || '').length }}/250
                            </span>
                        </div>
                        <input
                            *ngIf="canEditTierlisteMeta && isKommentarEditing"
                            #kommentarInput
                            class="la-detail-dialog__kommentar-input"
                            type="text"
                            [formControl]="kommentarCtrl"
                            maxlength="250"
                            placeholder="Optional"
                            (focus)="isKommentarEditing = true"
                            (blur)="finishKommentarEdit()"
                        />
                        <p
                            *ngIf="!canEditTierlisteMeta || !isKommentarEditing"
                            class="la-detail-dialog__card-value"
                            [class.la-detail-dialog__card-value--muted]="displayKommentarLabel === '—'"
                        >
                            {{ canEditTierlisteMeta ? displayKommentarLabel : ((tierliste?.kommentar || '').trim() || '—') }}
                        </p>
                    </div>

                    <div *ngIf="isAusstallen && row.tierliste_id" class="la-detail-dialog__card la-detail-dialog__card--full">
                        <div class="la-detail-dialog__card-head">
                            <span class="la-detail-dialog__card-label">
                                <mat-icon aria-hidden="true">{{
                                    isInternTransfer ? 'swap_horiz' : 'local_shipping'
                                }}</mat-icon>
                                {{ isInternTransfer ? 'Zielbetrieb' : 'Empfänger' }}
                            </span>
                            <button
                                *ngIf="canEditZielbetrieb"
                                type="button"
                                class="la-detail-dialog__card-edit"
                                [attr.aria-label]="zielCardAriaLabel"
                                (click)="onZielCardActivate($event)"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                        <div
                            *ngIf="zielbetriebDisplayEntries.length > 0; else zielEmpty"
                            class="la-detail-dialog__ziel-list"
                        >
                            <div
                                *ngFor="let entry of zielbetriebDisplayEntries; trackBy: trackZielDisplayEntry"
                                class="la-detail-dialog__ziel-entry"
                            >
                                <p class="la-detail-dialog__card-value">{{ entry.name }}</p>
                                <p
                                    *ngFor="let line of entry.detailLines; trackBy: trackZielDetailLine"
                                    class="la-detail-dialog__card-note"
                                >
                                    {{ line }}
                                </p>
                            </div>
                        </div>
                        <ng-template #zielEmpty>
                            <p class="la-detail-dialog__card-value la-detail-dialog__card-value--muted">
                                {{ getZielbetriebEmptyLabel() }}
                            </p>
                        </ng-template>
                    </div>

                    <div *ngIf="row.status_hinweis" class="la-detail-dialog__card la-detail-dialog__card--full">
                        <div class="la-detail-dialog__card-head">
                            <span class="la-detail-dialog__card-label">
                                <mat-icon aria-hidden="true">info</mat-icon>
                                Hinweis
                            </span>
                        </div>
                        <p class="la-detail-dialog__card-value">{{ row.status_hinweis }}</p>
                    </div>
                </div>

                <p
                    *ngIf="showImportClosedHint"
                    class="la-detail-dialog__hint la-detail-dialog__hint--warn"
                >
                    Import wurde geschlossen (Nicht importieren).
                </p>

                <div *ngIf="canShowPreis || canShowGewicht" class="la-detail-dialog__metrics-block">
                    <ng-template #laMetricModeToggle let-focus="focus" let-ariaLabel="ariaLabel">
                        <div
                            *ngIf="isMetricEditing(focus)"
                            class="la-detail-dialog__metric-mode-toggle"
                            role="group"
                            [attr.aria-label]="ariaLabel"
                            (click)="$event.stopPropagation()"
                        >
                            <button
                                type="button"
                                class="la-detail-dialog__metric-mode-btn"
                                [class.la-detail-dialog__metric-mode-btn--active]="
                                    getMetricEntryMode(focus) === 'gesamt'
                                "
                                (click)="setMetricEntryMode(focus, 'gesamt', $event)"
                            >
                                Gesamt
                            </button>
                            <button
                                type="button"
                                class="la-detail-dialog__metric-mode-btn"
                                [class.la-detail-dialog__metric-mode-btn--active]="
                                    getMetricEntryMode(focus) === 'proTier'
                                "
                                [disabled]="!canUseProTierMetricEntry()"
                                (click)="setMetricEntryMode(focus, 'proTier', $event)"
                            >
                                Pro Tier
                            </button>
                        </div>
                    </ng-template>

                    <ng-template #laMetricHead let-focus="focus" let-label="label" let-canEdit="canEdit">
                        <div class="la-detail-dialog__metric-head">
                            <div class="la-detail-dialog__metric-head-main">
                                <span class="la-detail-dialog__metric-label">{{ label }}</span>
                                <ng-container
                                    *ngTemplateOutlet="
                                        laMetricModeToggle;
                                        context: { focus: focus, ariaLabel: label + ' Eingabemodus' }
                                    "
                                ></ng-container>
                            </div>
                            <button
                                *ngIf="canEdit && !isMetricEditing(focus)"
                                type="button"
                                class="la-detail-dialog__card-edit"
                                [attr.aria-label]="label + ' bearbeiten'"
                                (click)="onMetricCardActivate(focus, $event); $event.stopPropagation()"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                    </ng-template>

                    <div class="la-detail-dialog__metrics-grid">
                        <!-- Einkaufspreis -->
                        <div
                            *ngIf="canShowPreis"
                            class="la-detail-dialog__metric"
                            [class.la-detail-dialog__metric--editable]="canEditMetric('einstall-preis')"
                            [class.la-detail-dialog__metric--editing]="isMetricEditing('einstall-preis')"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    laMetricHead;
                                    context: {
                                        focus: 'einstall-preis',
                                        label: 'Einkaufspreis',
                                        canEdit: canEditMetric('einstall-preis')
                                    }
                                "
                            ></ng-container>
                            <ng-container *ngIf="canEditMetric('einstall-preis'); else einstallPreisStatic">
                                <div class="la-detail-dialog__metric-body la-detail-dialog__metric-body--preis">
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--view"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            isMetricEditing('einstall-preis')
                                        "
                                    >
                                        <div class="la-detail-dialog__metric-readonly">
                                            <span
                                                class="la-detail-dialog__metric-value"
                                                [class.la-detail-dialog__metric-value--empty]="
                                                    isMetricDisplayEmpty(displayEinkaufPreisGesamt())
                                                "
                                            >
                                                {{ displayEinkaufPreisGesamt()
                                                }}<ng-container *ngIf="displayEinkaufPreisGesamt() !== '—'">
                                                    gesamt</ng-container
                                                >
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--edit"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            !isMetricEditing('einstall-preis')
                                        "
                                        (click)="$event.stopPropagation()"
                                    >
                                        <div class="la-detail-dialog__metric-input-row">
                                            <input
                                                [id]="'la-metric-input-einstall-preis-gesamt'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('einstall-preis') !== 'gesamt'
                                                "
                                                [formControl]="einkaufPreisCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Einkaufspreis gesamt"
                                                [attr.tabindex]="
                                                    isMetricEditing('einstall-preis') &&
                                                    getMetricEntryMode('einstall-preis') === 'gesamt'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <input
                                                [id]="'la-metric-input-einstall-preis-proTier'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('einstall-preis') !== 'proTier'
                                                "
                                                [formControl]="einkaufPreisProTierCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Einkaufspreis pro Tier"
                                                [attr.tabindex]="
                                                    isMetricEditing('einstall-preis') &&
                                                    getMetricEntryMode('einstall-preis') === 'proTier'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <span class="la-detail-dialog__metric-suffix">{{
                                                getMetricActiveSuffix('einstall-preis')
                                            }}</span>
                                        </div>
                                        <p
                                            *ngIf="getMetricCalculatedHint('einstall-preis')"
                                            class="la-detail-dialog__metric-calculated"
                                        >
                                            {{ getMetricCalculatedHint('einstall-preis') }}
                                        </p>
                                        <p
                                            *ngIf="canUseProTierMetricEntry() && metricTiereLabel()"
                                            class="la-detail-dialog__metric-tiere-hint"
                                        >
                                            {{ metricTiereLabel() }}
                                        </p>
                                        <mat-radio-group
                                            [formControl]="einkaufMwstCtrl"
                                            class="la-detail-dialog__metric-mwst"
                                        >
                                            <mat-radio-button [value]="7">7% MwSt.</mat-radio-button>
                                            <mat-radio-button [value]="9">9% MwSt.</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #einstallPreisStatic>
                                <div class="la-detail-dialog__metric-readonly">
                                    <span
                                        class="la-detail-dialog__metric-value"
                                        [class.la-detail-dialog__metric-value--empty]="
                                            isMetricDisplayEmpty(displayEinkaufPreisGesamt())
                                        "
                                    >
                                        {{ displayEinkaufPreisGesamt()
                                        }}<ng-container *ngIf="displayEinkaufPreisGesamt() !== '—'">
                                            gesamt</ng-container
                                        >
                                    </span>
                                </div>
                            </ng-template>
                        </div>

                        <!-- Verkaufspreis (Ausstallen) -->
                        <div
                            *ngIf="canShowPreis && isAusstallen"
                            class="la-detail-dialog__metric"
                            [class.la-detail-dialog__metric--editable]="canEditMetric('abgang-preis')"
                            [class.la-detail-dialog__metric--editing]="isMetricEditing('abgang-preis')"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    laMetricHead;
                                    context: {
                                        focus: 'abgang-preis',
                                        label: 'Verkaufspreis',
                                        canEdit: canEditMetric('abgang-preis')
                                    }
                                "
                            ></ng-container>
                            <ng-container *ngIf="canEditMetric('abgang-preis'); else verkaufPreisStatic">
                                <div class="la-detail-dialog__metric-body la-detail-dialog__metric-body--preis">
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--view"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            isMetricEditing('abgang-preis')
                                        "
                                    >
                                        <div class="la-detail-dialog__metric-readonly">
                                            <span
                                                class="la-detail-dialog__metric-value"
                                                [class.la-detail-dialog__metric-value--empty]="
                                                    isMetricDisplayEmpty(displayVerkaufPreisGesamt())
                                                "
                                            >
                                                {{ displayVerkaufPreisGesamt()
                                                }}<ng-container *ngIf="displayVerkaufPreisGesamt() !== '—'">
                                                    gesamt</ng-container
                                                >
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--edit"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            !isMetricEditing('abgang-preis')
                                        "
                                        (click)="$event.stopPropagation()"
                                    >
                                        <div class="la-detail-dialog__metric-input-row">
                                            <input
                                                [id]="'la-metric-input-abgang-preis-gesamt'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('abgang-preis') !== 'gesamt'
                                                "
                                                [formControl]="verkaufPreisCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Verkaufspreis gesamt"
                                                [attr.tabindex]="
                                                    isMetricEditing('abgang-preis') &&
                                                    getMetricEntryMode('abgang-preis') === 'gesamt'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <input
                                                [id]="'la-metric-input-abgang-preis-proTier'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('abgang-preis') !== 'proTier'
                                                "
                                                [formControl]="verkaufPreisProTierCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Verkaufspreis pro Tier"
                                                [attr.tabindex]="
                                                    isMetricEditing('abgang-preis') &&
                                                    getMetricEntryMode('abgang-preis') === 'proTier'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <span class="la-detail-dialog__metric-suffix">{{
                                                getMetricActiveSuffix('abgang-preis')
                                            }}</span>
                                        </div>
                                        <p
                                            *ngIf="getMetricCalculatedHint('abgang-preis')"
                                            class="la-detail-dialog__metric-calculated"
                                        >
                                            {{ getMetricCalculatedHint('abgang-preis') }}
                                        </p>
                                        <p
                                            *ngIf="canUseProTierMetricEntry() && metricTiereLabel()"
                                            class="la-detail-dialog__metric-tiere-hint"
                                        >
                                            {{ metricTiereLabel() }}
                                        </p>
                                        <mat-radio-group
                                            [formControl]="verkaufMwstCtrl"
                                            class="la-detail-dialog__metric-mwst"
                                        >
                                            <mat-radio-button [value]="7">7% MwSt.</mat-radio-button>
                                            <mat-radio-button [value]="9">9% MwSt.</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #verkaufPreisStatic>
                                <div class="la-detail-dialog__metric-readonly">
                                    <span
                                        class="la-detail-dialog__metric-value"
                                        [class.la-detail-dialog__metric-value--empty]="
                                            isMetricDisplayEmpty(displayVerkaufPreisGesamt())
                                        "
                                    >
                                        {{ displayVerkaufPreisGesamt()
                                        }}<ng-container *ngIf="displayVerkaufPreisGesamt() !== '—'">
                                            gesamt</ng-container
                                        >
                                    </span>
                                </div>
                            </ng-template>
                        </div>

                        <!-- Einstallgewicht -->
                        <div
                            *ngIf="canShowGewicht"
                            class="la-detail-dialog__metric"
                            [class.la-detail-dialog__metric--editable]="canEditMetric('einstall-gewicht')"
                            [class.la-detail-dialog__metric--editing]="isMetricEditing('einstall-gewicht')"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    laMetricHead;
                                    context: {
                                        focus: 'einstall-gewicht',
                                        label: 'Einstallgewicht',
                                        canEdit: canEditMetric('einstall-gewicht')
                                    }
                                "
                            ></ng-container>
                            <ng-container *ngIf="canEditMetric('einstall-gewicht'); else einstallGewichtStatic">
                                <div class="la-detail-dialog__metric-body la-detail-dialog__metric-body--gewicht">
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--view"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            isMetricEditing('einstall-gewicht')
                                        "
                                    >
                                        <div class="la-detail-dialog__metric-readonly">
                                            <span
                                                class="la-detail-dialog__metric-value"
                                                [class.la-detail-dialog__metric-value--empty]="
                                                    isMetricDisplayEmpty(displayEinstallGewichtGesamt())
                                                "
                                            >
                                                {{ displayEinstallGewichtGesamt()
                                                }}<ng-container *ngIf="displayEinstallGewichtGesamt() !== '—'">
                                                    gesamt</ng-container
                                                >
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--edit"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            !isMetricEditing('einstall-gewicht')
                                        "
                                        (click)="$event.stopPropagation()"
                                    >
                                        <div class="la-detail-dialog__metric-input-row">
                                            <input
                                                [id]="'la-metric-input-einstall-gewicht-gesamt'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('einstall-gewicht') !== 'gesamt'
                                                "
                                                [formControl]="einstallGewichtCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Einstallgewicht gesamt"
                                                [attr.tabindex]="
                                                    isMetricEditing('einstall-gewicht') &&
                                                    getMetricEntryMode('einstall-gewicht') === 'gesamt'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <input
                                                [id]="'la-metric-input-einstall-gewicht-proTier'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('einstall-gewicht') !== 'proTier'
                                                "
                                                [formControl]="einstallGewichtProTierCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Einstallgewicht pro Tier"
                                                [attr.tabindex]="
                                                    isMetricEditing('einstall-gewicht') &&
                                                    getMetricEntryMode('einstall-gewicht') === 'proTier'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <span class="la-detail-dialog__metric-suffix">{{
                                                getMetricActiveSuffix('einstall-gewicht')
                                            }}</span>
                                        </div>
                                        <p
                                            *ngIf="getMetricCalculatedHint('einstall-gewicht')"
                                            class="la-detail-dialog__metric-calculated"
                                        >
                                            {{ getMetricCalculatedHint('einstall-gewicht') }}
                                        </p>
                                        <p
                                            *ngIf="canUseProTierMetricEntry() && metricTiereLabel()"
                                            class="la-detail-dialog__metric-tiere-hint"
                                        >
                                            {{ metricTiereLabel() }}
                                        </p>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #einstallGewichtStatic>
                                <div class="la-detail-dialog__metric-readonly">
                                    <span
                                        class="la-detail-dialog__metric-value"
                                        [class.la-detail-dialog__metric-value--empty]="
                                            isMetricDisplayEmpty(displayEinstallGewichtGesamt())
                                        "
                                    >
                                        {{ displayEinstallGewichtGesamt()
                                        }}<ng-container *ngIf="displayEinstallGewichtGesamt() !== '—'">
                                            gesamt</ng-container
                                        >
                                    </span>
                                </div>
                            </ng-template>
                        </div>

                        <!-- Abgangsgewicht (Ausstallen) -->
                        <div
                            *ngIf="canShowGewicht && isAusstallen"
                            class="la-detail-dialog__metric"
                            [class.la-detail-dialog__metric--editable]="canEditMetric('abgang-gewicht')"
                            [class.la-detail-dialog__metric--editing]="isMetricEditing('abgang-gewicht')"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    laMetricHead;
                                    context: {
                                        focus: 'abgang-gewicht',
                                        label: 'Abgangsgewicht',
                                        canEdit: canEditMetric('abgang-gewicht')
                                    }
                                "
                            ></ng-container>
                            <ng-container *ngIf="canEditMetric('abgang-gewicht'); else abgangGewichtStatic">
                                <div class="la-detail-dialog__metric-body la-detail-dialog__metric-body--gewicht">
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--view"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            isMetricEditing('abgang-gewicht')
                                        "
                                    >
                                        <div class="la-detail-dialog__metric-readonly">
                                            <span
                                                class="la-detail-dialog__metric-value"
                                                [class.la-detail-dialog__metric-value--empty]="
                                                    isMetricDisplayEmpty(displayAbgangGewichtGesamt())
                                                "
                                            >
                                                {{ displayAbgangGewichtGesamt()
                                                }}<ng-container *ngIf="displayAbgangGewichtGesamt() !== '—'">
                                                    gesamt</ng-container
                                                >
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="la-detail-dialog__metric-pane la-detail-dialog__metric-pane--edit"
                                        [class.la-detail-dialog__metric-pane--hidden]="
                                            !isMetricEditing('abgang-gewicht')
                                        "
                                        (click)="$event.stopPropagation()"
                                    >
                                        <div class="la-detail-dialog__metric-input-row">
                                            <input
                                                [id]="'la-metric-input-abgang-gewicht-gesamt'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('abgang-gewicht') !== 'gesamt'
                                                "
                                                [formControl]="abgangGewichtCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Abgangsgewicht gesamt"
                                                [attr.tabindex]="
                                                    isMetricEditing('abgang-gewicht') &&
                                                    getMetricEntryMode('abgang-gewicht') === 'gesamt'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <input
                                                [id]="'la-metric-input-abgang-gewicht-proTier'"
                                                class="la-detail-dialog__metric-input"
                                                [class.la-detail-dialog__metric-input--hidden]="
                                                    getMetricEntryMode('abgang-gewicht') !== 'proTier'
                                                "
                                                [formControl]="abgangGewichtProTierCtrl"
                                                inputmode="decimal"
                                                type="number"
                                                aria-label="Abgangsgewicht pro Tier"
                                                [attr.tabindex]="
                                                    isMetricEditing('abgang-gewicht') &&
                                                    getMetricEntryMode('abgang-gewicht') === 'proTier'
                                                        ? 0
                                                        : -1
                                                "
                                            />
                                            <span class="la-detail-dialog__metric-suffix">{{
                                                getMetricActiveSuffix('abgang-gewicht')
                                            }}</span>
                                        </div>
                                        <p
                                            *ngIf="getMetricCalculatedHint('abgang-gewicht')"
                                            class="la-detail-dialog__metric-calculated"
                                        >
                                            {{ getMetricCalculatedHint('abgang-gewicht') }}
                                        </p>
                                        <p
                                            *ngIf="canUseProTierMetricEntry() && metricTiereLabel()"
                                            class="la-detail-dialog__metric-tiere-hint"
                                        >
                                            {{ metricTiereLabel() }}
                                        </p>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #abgangGewichtStatic>
                                <div class="la-detail-dialog__metric-readonly">
                                    <span
                                        class="la-detail-dialog__metric-value"
                                        [class.la-detail-dialog__metric-value--empty]="
                                            isMetricDisplayEmpty(displayAbgangGewichtGesamt())
                                        "
                                    >
                                        {{ displayAbgangGewichtGesamt()
                                        }}<ng-container *ngIf="displayAbgangGewichtGesamt() !== '—'">
                                            gesamt</ng-container
                                        >
                                    </span>
                                </div>
                            </ng-template>
                        </div>

                        <ng-container *ngIf="showAusstallenErloesTageszunahmen">
                            <div *ngIf="canShowPreis" class="la-detail-dialog__metric la-detail-dialog__metric--readonly">
                                <span class="la-detail-dialog__metric-label">Erlösdifferenz / Tag</span>
                                <span class="la-detail-dialog__metric-value">{{
                                    formatPreis(row.erloesdifferenz_avg)
                                }}</span>
                            </div>
                            <div *ngIf="canShowGewicht" class="la-detail-dialog__metric la-detail-dialog__metric--readonly">
                                <span class="la-detail-dialog__metric-label">Tageszunahme (Ø)</span>
                                <span class="la-detail-dialog__metric-value">{{
                                    formatTageszunahmen(row.tageszunahmen_avg)
                                }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>
        </ng-container>
    </div>

    <div
        mat-dialog-actions
        class="la-detail-dialog__actions"
        [class.la-detail-dialog__actions--import-ready]="isPendingImportOverview"
        align="end"
    >
        <button
            *ngIf="canShowContinueScansButton || canShowScansFortsetzenButton"
            type="button"
            mat-stroked-button
            color="primary"
            (click)="onScansFortsetzen()"
            [disabled]="isLoading || isSaving || !!loadError"
        >
            Scans fortsetzen
        </button>
        <button
            *ngIf="canShowListeAbschliessenButton"
            type="button"
            mat-stroked-button
            color="primary"
            (click)="listeAbschliessen()"
            [disabled]="isLoading || isSaving || !!loadError"
        >
            Liste abschliessen
        </button>
        <button
            *ngIf="canShowImportierenButton && isPendingImportOverview"
            type="button"
            mat-flat-button
            color="primary"
            class="la-detail-dialog__import-btn"
            (click)="inGruppeImportieren()"
            [disabled]="isLoading || isSaving || !!loadError"
        >
            In Gruppe importieren
        </button>
        <button
            *ngIf="canShowImportierenButton && !isPendingImportOverview"
            type="button"
            mat-stroked-button
            color="primary"
            class="la-detail-dialog__import-btn"
            (click)="inGruppeImportieren()"
            [disabled]="isLoading || isSaving || !!loadError"
        >
            In Gruppe importieren
        </button>
    </div>
</div>
